import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },
  '& .checkout_stripe_payment': {
    '& .promo-spinner': {
      backgroundColor: 'unset',
    },
  },

  '.smileobsession-container': {
    '& .book-now-button': {
      fontSize: 20,
    },
    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      background: palette.background.primary,
      '& .hero-header-title, & .hero-header-subtitle': {
        color: palette.text.highlight,
      }
    },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    '& .plan-selection-container': {
      '& .planCard': {
        '&:hover': {
          color: 'inherit !important',
          background: 'inherit !important',
        },
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.main,
      '& .section-header__cta-item-wrapper': {
        '@media(max-width:600px)': {
          width: '100% !important',
          display: 'flex !important',
          flexDirection: 'column !important',
          justifyContent: 'space-between !important',
          alignItems: 'center !important',
          gap: '10px !important',
        },
        '& button': {
          '@media(max-width:600px)': {
            width: '100% !important',
            marginLeft: '0px !important',
          },
        },
      },
      '& .section-alternate__content': {

        padding: '0px 20px',
        paddingTop: '85px',
        '@media(max-width:600px)': {
          paddingBottom: '40px !important',
        },

        '@media(min-width: 600px)': {
          padding: '0px 20px',
          paddingTop: '85px',
        },

        '@media(min-width: 900px)': {
          padding: '0px 60px',
          paddingTop: '85px',
        },

        '@media (min-width: 900px) and (max-width: 1200px)': {
          '& .section-alternate__content': {
            paddingLeft: '60px',
            paddingRight: '60px',
          },

          '@media (min-width: 900px) and (max-width: 1366px)': {
          '& .section-alternate__content': {
            paddingLeft: '60px',
            paddingRight: '60px',
            },
          },


          '& .hero-section-alternate': {
            maxWidth: 'unset',
            margin: 0,
            },
          },

          '@media(min-width: 1600px)': {
            padding: '16px 96px',
            paddingTop: '85px',
          },
      },

      '& .home-hero-title': {
        maxWidth: 500,
        fontWeight: 600,
      },
      '& .home-hero-subtitle': {
        maxWidth: 450
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '550px',
        padding: '0px 12px',

        '@media(min-width: 900px)': {
          padding: '40px 60px 80px',
        },
        '@media(min-width: 1600px)': {
          padding: '40px 0px 80px',
        },
      },
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '@media(min-width: 900px)': {
          paddingTop: 120,
        },

        '& .hero-title': {
          fontSize: 42,
          fontWeight: 600,
          lineHeight: '55px',

          '@media(min-width: 600px)': {
            fontSize: 48,
            lineHeight: '60px',
          },

          '@media(min-width: 900px)': {
            fontSize: 64,
            lineHeight: '80px',
            letterSpacing: '-0.04em',
            maxWidth: 600,
          },
        },
        '& .hero-subtitle': {
          fontWeight: 400,
          fontSize: 16,
          lineHeight: '30px',
          maxWidth: 600,
          '@media(min-width: 900px)': {
            fontSize: 20,
          }
        },
        '& .MuiButton-label': {
          fontSize: 15,
          letterSpacing: '-0.03em',
        },
      },
      '& .hero-background': {
        objectFit: 'cover',
      },
      '& .image-wrapper': {
        paddingBottom: 0,
        marginBottom: -5,

        '& .image': {
          '@media(min-width: 900px)': {
            height: 688,
            width: 'auto',
          },
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-variant-2': {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
      '& .section-alternate__content': {
        padding: '72px 48px',
      },

      '@media(max-width: 900px)': {
        padding: 0,
      },

      '& .benefits-wrapper': {
        padding: '0px 20px',
        '@media(min-width: 900px)': {
          padding: '0px 60px 0px',
        },
        '@media(min-width: 1600px)': {
          padding: '16px 96px'
        },
        '& .section-header__title': {
          paddingBottom: 18,

          '@media(max-width: 900px)': {
            paddingBottom: 24,
          },
        },
        '& .definition-service-title': {
          fontSize: 24,
          fontWeight: 600,
        },
        '& .definition-service-innertile': {
          height: '100% !important',
        },
        '& .definition-service-description': {
          fontSize: 16,
          fontWeight: 400,
          paddingBottom: 40,
          color: '#64748B',
          borderBottom: `1px solid #C9D5E0`,

          '@media(min-width: 900px)': {
            maxWidth: '100% !important',
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.primary,
      },
      '& .plans-loader': {
        color: palette.text.highlight,
      },
      '& #pricing-benefit-section': {
        '& .section-header__title, .section-header__subtitle': {
          color: palette.text.highlight,
          fontWeight: 'normal',
        },
        '& .section-header__title': {
          letterSpacing: '-0.04em',
        },
        '& .section-header__subtitle': {
          fontSize: 20,
          fontWeight: 400,
          letterSpacing: '-0.02em',
          maxWidth: 713,
          margin: '0 auto',
        },
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
          },
          '& .customGetStarted': {
            width: '96%',
            borderColor: palette.primary.main,
          },
        },
        '& .subscription-tabs-label, .summary-subtext, .summary-text': {
          color: palette.text.highlight,
        },
        '& .summary-subtext': {
          fontSize: 18,
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.primary.main,
          cursor: 'pointer',
        },
      },
      '& .react-multi-carousel-dot button': {
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        background: palette.text.highlight,
        border: 'none',
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        background: palette.background.primary,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .section': {
          padding: '48px 20px',

        '@media(min-width: 600px)': {
          padding: '48px',
        },

        '@media(min-width: 900px)': {
          padding: '72px 20px 80px',
        },
      },

      '& .howitworks-wrapper-left': {
        paddingRight: 80,
        '@media(max-width: 600px)': {
          paddingRight: 12,
        },
      },
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .section-header__subtitle-wrapper': {
        fontSize: 18,
        fontWeight: 400,
        color: '#5A5A5A',
      },
      '& .how-cover-image': {
        height: 550,
        borderRadius: 24,
        '@media(max-width: 900px)': {
          height: '100%',
        },
      },
      '& .step-content': {
        maxWidth: 400,
        color: '#5A5A5A',
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.02em',
      },
      '& .working-steps-container': {
        paddingBottom: 24,
        marginBottom: 8,
        borderBottom: '1px solid #707d9433',

        '& .step-counter': {
          borderRadius: '36px',
          backgroundColor: palette.background.steps,
          color: palette.text.highlight,
        },
        '& .step-title': {
          fontSize: 24,
          fontWeight: 500,
          letterSpacing: '-0.01em',
        },
      },
    },

    '& .find-provider-section': {
      '& .hero-home-button':{
        '&:hover': {
          backgroundColor: palette.text.highlight,
          borderColor:'none !important',
        },
      }
    },
    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.light,
      '& .section-header__title': {
        fontWeight: 'normal',
        letterSpacing: '-0.04em',
      },
      '& .react-multi-carousel-list': {
        overflow: 'visible',

        '&:before, &:after': {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: 0,
          zIndex: 1,

          '@media(min-width: 600px)': {
            width: 350,
          },
          '@media(min-width: 900px)': {
            width: 450,
          },
          '@media(min-width: 1200px)': {
            width: 550,
          },
        },
        '&:before': {
          left: -115,
          background:
            'linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
        '&:after': {
          right: -130,
          background:
            'linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
      },
      '& .patient-label': {
        fontWeight: 500,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar': {
        backgroundColor: palette.background.primary,

        '& .footer-bar-text': {
          color: palette.text.highlight,
        },
      },
      '& .savings-contact-card': {
        padding: '0px !important',
        background: palette.background.footer,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-title': {
        fontWeight: 'normal',
        letterSpacing: '-0.04em',
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary,
      },
      '& .hero-button-wrapper': {
        '& .primary-static-button': {
          backgroundColor: palette.primary.main,
        },
        '@media(min-width: 900px)': {
          display: 'flex',
          justifyContent: 'right',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: palette.text.highlight,
      },
    },

    '& .success-wrapper': {
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.text.highlight,
        border: `1px solid ${palette.primary.main}`,
        color: palette.primary.main,
      },
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        textAlign: 'center',
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .MuiGrid-container':{
        padding:12,
      },  
      '& .MuiButton-outlinedPrimary': {
        '& .MuiSvgIcon-root, & svg': {
          fill: `${palette.primary.main} !important`,
          color: `${palette.primary.main} !important`,
          '& path, & circle, & rect, & polygon, & line, & polyline': {
            fill: `${palette.primary.main} !important`,
            stroke: `${palette.primary.main} !important`,
          },
        },
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
        padding: 0,
        marginRight: 8,
      },
      '& .provider-contact-details': {
        fontSize: 18,
        fontWeight: 400,
      },
      '& .provider-contact-link': {
        fontSize: 24,
        fontWeight: 500,
      },
      '& .faq-contact-section': {
        '@media(max-width: 600px)': {
          padding: '48px 32px !important',
        },
      },
    },

    /* Subscription Success Page */
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Footer style */
    '& .footer-wrapper': {
      background: palette.text.highlight,
      borderTop: `1px solid ${palette.divider}`,
      '& .MuiGrid-item': {
        '@media(max-width: 600px)': {
          padding: '16px 28px'
        },
        '@media(max-width: 900px) and (min-width: 600px)': {
          padding: '16px 32px'
        },
        '@media(min-width: 900px) and (max-width: 1600px)': {
          padding: '16px 40px'
        },
        '@media(min-width: 1600px)': {
          padding: '16px 70px',
        },
      }
    },

    '& .leftWrapper': {
      '& .cardRoot': {
        border: `1px solid ${palette.border}`,
        '&:hover': {
          border: `1px solid ${palette.primary.main}`,
        },
      },
    },
    '& .address-suggestion-field': {
      '& fieldset': {
        border: `1px solid ${palette.border} !important`,
      },
    },
    '& .timeSlot': {
      border: `1px solid ${palette.border} !important`,
      '&:hover': {
        border: `1px solid ${palette.primary.main} !important`,
      },
    },
    '& .proximityIcon': {
      padding: '8px !important',
    },
    '& .has-border':{
      border: `1px solid ${palette.background.cardBorder} !important`,
    }
  },
};
